var React = require('react');

function FacebookBox (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"fill":"#3C5A99","width":"20","height":"20","rx":"2","key":0}),React.createElement("path",{"d":"M14 20v-8h2.65l.38-3H14V7.28c0-.87.3-1.47 1.54-1.47h1.6V3.14C16.86 3.08 15.92 3 14.8 3c-2.3 0-3.86 1.4-3.86 3.98V9h-2.6v3h2.6v8H14z","fill":"#FFF","style":{"fill":"#FFF"},"fillRule":"nonzero","key":1})]));
}

FacebookBox.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = FacebookBox;

FacebookBox.default = FacebookBox;
